import fetch ,{postFrom,getBlob2} from "../utils/fetch";

export function incomeAndCostlist(params) {
  return fetch({
    method: 'POST',
    url: '/management/board/incomeAndCost/list',
    data:params
  })
}

export function profitGraphlist(params) {
  return fetch({
    method: 'POST',
    url: '/management/board/profitGraph/list',
    data:params
  })
}

export function managementcards(params) {
  return fetch({
    method: 'POST',
    url: '/management/cards',
    data:params
  })
}
